import React from 'react';
import { EXEC_STATUSES, type ExecStatus } from '../theme/decisionTokens';

export interface ExecStatusPillProps {
  status: string;
}

export const ExecStatusPill: React.FC<ExecStatusPillProps> = ({ status }) => {
  const token = EXEC_STATUSES[status as ExecStatus] ?? EXEC_STATUSES['Approval Pending'];
  return (
    <span
      className="inline-flex items-center gap-1.5 rounded-full font-bold px-2.5 py-0.5 text-xs"
      style={{ background: token.bg, color: token.fg }}
    >
      <span className="w-1.5 h-1.5 rounded-full" style={{ background: token.dot }} />
      {status}
    </span>
  );
};

export default ExecStatusPill;
